import { useContext, useEffect, useState } from 'react'
import DownloadReuploadSection from './DownloadReuploadSection';
import { useTranslation } from 'react-i18next';
import { GlobalContext } from '../../../../context/GlobalContext';
import './RedownloadAttachments.scss';
import CardButtonLeftArrow from '../../../../assets/CardButtonLeftArrow.svg'
import Loader from '../../../Loader/Loader';

export interface Props {
    rtl: boolean;
}

const win: any = window;
function RedownloadAttachments({ rtl }: any) {
    const { t } = useTranslation();
    const [state, dispatch]: any = useContext(GlobalContext);
    const { productType, customerType, } = state;
    // const [loading, setLoading] = useState(true);
    const { loading } = state

    const dir = rtl ? 'right' : 'left';

    const handleBack = () => {
        // dispatch({ type: 'SET_BACK_BUTTON', payload: { page: productType === "Voice" && productType === "Data" ? t("Delivery_Details") : t("Product_Information") } })
        window.location = win['home_page_url'];
    }
    useEffect(() => {
        const timer = setTimeout(() => {
            dispatch({ type: 'LOADER', payload: { loading: false } })
        }, 1000);

        return () => clearTimeout(timer);
    }, []);

    return (
        <>
            <div className="container">
                {loading && (
                    <div className="loading-overlay">
                        <Loader />
                    </div>
                )}
                <div className="row">
                    <div className="col-sm-12 d-flex">
                        <div className={`back-icon-containers ${dir}`} onClick={handleBack}>
                            <img className={`back-icon`} src={CardButtonLeftArrow} alt="arrow" />
                        </div>
                    </div>
                    <div className={`col-sm-12 upload-attachment-container da-${dir} order-detail-popup`}>
                        <DownloadReuploadSection rtl={rtl} />
                    </div>

                </div>
            </div>
        </>
    )
}

export default RedownloadAttachments
